<template>
    <div class="download">
				<el-dropdown @command="handleCommand" trigger='click'   >
					<span class="el-dropdown-link">
						导出<i class="el-icon-arrow-down el-icon--right"></i>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="当前页数据">
							<download-excel
								:data= "tableListData.rows"
								:fields='downloadFileds'
								name= "当前页列表.xls"
								>
							当前页数据
							</download-excel>
						</el-dropdown-item>
						<el-dropdown-item command="所有数据">
                <download-excel
								:data= "tableListDataAll.rows"
								:fields='downloadFileds'
								name= "所有列表.xls"
								>
							所有数据
							</download-excel>
            </el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>		
	</div>
</template>
<script>
export default{
	data(){
		return{
			
		}
	},
	props:{
		tableListData:{},
		tableListDataAll:{},
		downloadFileds:{}
	},
	methods:{
		handleCommand(command){
		
		},
		// loadDataAll(){
			
		// 	this.$parent.tableListAll();
		// 	}

	},
	mounted(){
		// console.log("00000")
		// console.log(this.tableListDataAll.rows)
	}
}
</script>
<style scoped>
 .el-dropdown-link {
	 display: inline-block;;
    cursor: pointer;
	color:white;
	background:#278cd8;
	height:34px;
	border-radius: 5px;
	padding-left:5px;
	font-size: 12px;
	line-height:37px;
	width:90px;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>
